import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const MastersDegreeIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>{educationLevels().level8.label}</title>
      <path
        d="M313.2,729.6h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2c0,6.9,5.6,12.5,12.5,12.5h72.8c6.9,0,12.5-5.6,12.5-12.5V742
		C325.6,735.1,320.1,729.6,313.2,729.6z M300.7,822.7h-47.9v-68.3h47.9V822.7z"
      />
      <path
        d="M689.3,847.7h72.8c6.9,0,12.5-5.6,12.5-12.5V742c0-6.9-5.6-12.5-12.5-12.5h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2
		C676.8,842.1,682.4,847.7,689.3,847.7z M701.7,754.5h47.9v68.3h-47.9V754.5z"
      />
      <path
        d="M313.2,590.8h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2c0,6.9,5.6,12.5,12.5,12.5h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2
		C325.6,596.4,320.1,590.8,313.2,590.8z M300.7,684h-47.9v-68.3h47.9V684z"
      />
      <path
        d="M313.2,452h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2c0,6.9,5.6,12.5,12.5,12.5h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2
		C325.6,457.6,320.1,452,313.2,452z M300.7,545.2h-47.9v-68.3h47.9V545.2z"
      />
      <path
        d="M388.3,708.9h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2c0-6.9-5.6-12.5-12.5-12.5h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2
		C375.8,703.3,381.4,708.9,388.3,708.9z M400.7,615.7h47.9V684h-47.9V615.7z"
      />
      <path
        d="M388.3,570.1h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2c0-6.9-5.6-12.5-12.5-12.5h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2
		C375.8,564.6,381.4,570.1,388.3,570.1z M400.7,476.9h47.9v68.3h-47.9V476.9z"
      />
      <path
        d="M614.2,590.8h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2c0,6.9,5.6,12.5,12.5,12.5h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2
		C626.6,596.4,621.1,590.8,614.2,590.8z M601.7,684h-47.9v-68.3h47.9V684z"
      />
      <path
        d="M528.9,464.5v93.2c0,6.9,5.6,12.5,12.5,12.5h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2c0-6.9-5.6-12.5-12.5-12.5h-72.8
		C534.5,452,528.9,457.6,528.9,464.5z M553.8,476.9h47.9v68.3h-47.9V476.9z"
      />
      <path
        d="M689.3,708.9h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2c0-6.9-5.6-12.5-12.5-12.5h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2
		C676.8,703.3,682.4,708.9,689.3,708.9z M701.7,615.7h47.9V684h-47.9V615.7z"
      />
      <path
        d="M689.3,570.1h72.8c6.9,0,12.5-5.6,12.5-12.5v-93.2c0-6.9-5.6-12.5-12.5-12.5h-72.8c-6.9,0-12.5,5.6-12.5,12.5v93.2
		C676.8,564.6,682.4,570.1,689.3,570.1z M701.7,476.9h47.9v68.3h-47.9V476.9z"
      />
      <path
        d="M501.7,397.9c48.4,0,87.8-39.4,87.8-87.8c0-48.4-39.4-87.8-87.8-87.8s-87.8,39.4-87.8,87.8
		C413.9,358.5,453.3,397.9,501.7,397.9z M501.7,247.3c34.7,0,62.8,28.2,62.8,62.9S536.3,373,501.7,373s-62.8-28.2-62.8-62.8
		S467,247.3,501.7,247.3z"
      />
      <path
        d="M502.7,326.5h30.7c6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5h-18.2v-20.2c0-6.9-5.6-12.5-12.5-12.5
		c-6.9,0-12.5,5.6-12.5,12.5v32.7C490.2,321,495.8,326.5,502.7,326.5z"
      />
      <path
        d="M1000.4,856.9c0-34.1-27.7-61.8-61.8-61.8s-61.8,27.7-61.8,61.8c0,29.8,21.2,54.8,49.3,60.5v56.8h-71.7V405.7
		c0-6.9-5.6-12.5-12.5-12.5H716.7V276c0-4.1-2-7.9-5.3-10.2L515.4,128.6V93.4h82.1c6.9,0,12.5-5.6,12.5-12.5V14.1
		c0-6.9-5.6-12.5-12.5-12.5h-94.5c-6.9,0-12.5,5.6-12.5,12.5v114.4L292.1,265.7c-3.4,2.3-5.4,6.2-5.4,10.2v117.3H161.4
		c-6.9,0-12.5,5.6-12.5,12.5v568.4H74.7v-56.8c28.1-5.8,49.3-30.7,49.3-60.5c0-34.1-27.7-61.8-61.8-61.8S0.4,822.8,0.4,856.9
		c0,29.8,21.2,54.8,49.4,60.5v56.8H15.4c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5H988c6.9,0,12.5-5.6,12.5-12.5
		s-5.6-12.5-12.5-12.5h-36.9v-56.8C979.2,911.6,1000.4,886.7,1000.4,856.9z M25.4,856.9c0-20.3,16.5-36.9,36.9-36.9
		s36.9,16.5,36.9,36.9c0,20.3-16.5,36.9-36.9,36.9S25.4,877.2,25.4,856.9z M585,68.4h-69.6V26.6H585V68.4z M173.9,418.2h125.3
		c6.9,0,12.5-5.6,12.5-12.5V282.5l191.3-132.2l188.9,132.2v123.3c0,6.9,5.6,12.5,12.5,12.5h125.3v556H627.6V741.8
		c0-6.9-5.6-12.5-12.5-12.5H388.3c-6.9,0-12.5,5.6-12.5,12.5v232.4H173.9V418.2z M515.4,754.3h87.2v219.9h-87.2V754.3z M490.5,974.2
		h-89.7V754.3h89.7V974.2z M901.8,856.9c0-20.3,16.5-36.9,36.9-36.9c20.3,0,36.9,16.5,36.9,36.9c0,20.3-16.5,36.9-36.9,36.9
		C918.3,893.8,901.8,877.2,901.8,856.9z"
      />
    </svg>
  );
};

export default MastersDegreeIcon;

MastersDegreeIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
